// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"ea641652","359":"dec934c8"}[chunkId] + ".chunk.js";
};